<script lang="ts">
  import ProductCard from '$components/product-card/product-card.svelte';
  import Skeleton from '$components/ui/skeleton.svelte';
  import type { LanguageCode } from '$gql/storefront/schemas';

  import { optimalUSCountry, parseCountryAsCode } from '$lib/country';
  import { lang } from '$lib/lang';
  import { shopify } from '$lib/shopify';
  import { isCmsStory } from '$lib/utils/cms';
  import type { SingleProductStoryblok } from '$types/bloks';
  import { createQuery } from '@tanstack/svelte-query';

  export let content: SingleProductStoryblok;

  $: handle = isCmsStory(content.product) ? content.product.slug : '';

  const query = createQuery({
    staleTime: 5 * 60 * 1000,
    queryKey: ['productCard', handle],
    queryFn: async () => {
      return await $shopify.getProductCard({
        handle,
        lang: $lang.toUpperCase() as LanguageCode,
        country: parseCountryAsCode($optimalUSCountry)
      });
    }
  });
</script>

<div class="w-full">
  {#if $query.isLoading}
    <Skeleton class="lg:min-h-[512px] lg:max-h-[512px] ml-auto rounded-md aspect-[332/480]" />
  {:else if $query.data?.product}
    {@const product = $query.data?.product}
    <ProductCard {product} variant="highlight" class="lg:min-h-[512px] lg:max-h-[512px] ml-auto" />
  {/if}
</div>
